import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createSlots as _createSlots, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5d151044"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dynamic-content" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  viewBox: "0 0 1024 1024",
  xmlns: "http://www.w3.org/2000/svg",
  "data-v-ba633cb8": ""
}, [
  /*#__PURE__*/_createElementVNode("path", {
    fill: "currentColor",
    d: "m795.904 750.72 124.992 124.928a32 32 0 0 1-45.248 45.248L750.656 795.904a416 416 0 1 1 45.248-45.248zM480 832a352 352 0 1 0 0-704 352 352 0 0 0 0 704zm-32-384v-96a32 32 0 0 1 64 0v96h96a32 32 0 0 1 0 64h-96v96a32 32 0 0 1-64 0v-96h-96a32 32 0 0 1 0-64h96z"
  })
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  viewBox: "0 0 1024 1024",
  xmlns: "http://www.w3.org/2000/svg",
  "data-v-ba633cb8": ""
}, [
  /*#__PURE__*/_createElementVNode("path", {
    fill: "currentColor",
    d: "m795.904 750.72 124.992 124.928a32 32 0 0 1-45.248 45.248L750.656 795.904a416 416 0 1 1 45.248-45.248zM480 832a352 352 0 1 0 0-704 352 352 0 0 0 0 704zm-32-384v-96a32 32 0 0 1 64 0v96h96a32 32 0 0 1 0 64h-96v96a32 32 0 0 1-64 0v-96h-96a32 32 0 0 1 0-64h96z"
  })
], -1))
const _hoisted_4 = { class: "dynamic-content-preview-card" }

import { App, onBeforeUnmount, onMounted, ref, watch } from "vue";
import { ElCard, ElIcon, ElDialog } from "element-plus";

import useCompileQuestionTitle from "@/hooks/useCompileContent";
import { addMaxHeightToImageStr, addMaxWidthToImageStr } from "@/utils/common";


export default /*#__PURE__*/_defineComponent({
  props: {
  title: {
    type: String,
  },
  content: {
    type: String,
  },
  simple: {
    type: Boolean,
    default: false,
  },
  // 是否对图片大小转为rem处理，小框内均不转换
  isResizeImgToRem: {
    type: Boolean,
    default: true,
  },
},
  setup(__props) {

const props = __props



const { compileContent: compileContentForRem } = useCompileQuestionTitle(
  props.isResizeImgToRem
);
const { compileContent } = useCompileQuestionTitle();

// const content = ref(props.content || "");
const content: any = ref(props.content || "");
watch(
  () => props.content,
  async (value) => {
    content.value = value || "";
    if (sourceApp.value) {
      sourceApp.value.unmount();
    }
    sourceApp.value = await compileContentForRem(
      sourceAppEle.value!,
      addMaxHeightToImageStr(content.value)
    )!;
  }
);

let sourceApp = ref<App | null>(null);
const sourceAppEle = ref<HTMLDivElement>();
let previewApp = ref<App | null>(null);
const previewAppEle = ref<HTMLDivElement>();

const isShowPreview = ref(false);

const simple: any = ref(props.simple);

const onPreviewClick = () => {
  if (previewApp.value) {
    previewApp.value.unmount();
    previewApp.value = null;
    isShowPreview.value = false;
    return;
  }
  setTimeout(async () => {
    previewApp.value = await compileContent(
      previewAppEle.value!,
      addMaxWidthToImageStr(content.value)
    )!;
  }, 0);
  isShowPreview.value = true;
};

const closePreview = () => {
  if (previewApp.value) {
    previewApp.value.unmount();
    previewApp.value = null;
    isShowPreview.value = false;
    return;
  }
};
onMounted(async () => {
  sourceApp.value = await compileContentForRem(
    sourceAppEle.value!,
    addMaxHeightToImageStr(content.value)
  )!;
});

onBeforeUnmount(() => {
  sourceApp.value && sourceApp.value.unmount();
  previewApp.value && previewApp.value.unmount();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(ElCard), { style: {"position":"relative"} }, _createSlots({
      default: _withCtx(() => [
        _createElementVNode("div", {
          class: "dynamic-content-container",
          ref_key: "sourceAppEle",
          ref: sourceAppEle
        }, null, 512),
        (simple.value)
          ? (_openBlock(), _createBlock(_unref(ElIcon), {
              key: 0,
              onClick: onPreviewClick,
              class: "dynamic-content-zoomin-simple"
            }, {
              default: _withCtx(() => [
                _hoisted_3
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 2
    }, [
      (!simple.value)
        ? {
            name: "header",
            fn: _withCtx(() => [
              _createTextVNode(_toDisplayString(props.title || "") + " ", 1),
              _createVNode(_unref(ElIcon), {
                onClick: onPreviewClick,
                class: "dynamic-content-zoomin"
              }, {
                default: _withCtx(() => [
                  _hoisted_2
                ]),
                _: 1
              })
            ])
          }
        : undefined
    ]), 1024),
    _createVNode(_unref(ElDialog), {
      class: "el-dialog",
      top: '15px',
      modelValue: isShowPreview.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((isShowPreview).value = $event)),
      onClose: closePreview,
      "append-to-body": true
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", {
            class: "dynamic-content-preview",
            ref_key: "previewAppEle",
            ref: previewAppEle
          }, null, 512)
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})